"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = user;
var _uniqBy = _interopRequireDefault(require("lodash/uniqBy"));
var _arrayHelper = require("../../helpers/arrayHelper");
var _userActions = require("../actions/userActions");
var _withdrawActions = require("../actions/withdrawActions");
var _kycActions = require("../actions/kycActions");
var _kycIdentityMindActions = require("../actions/kycIdentityMindActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = {
  userInfo: {},
  permissions: [],
  accounts: [],
  userConfig: [],
  selectedAccountId: parseInt(localStorage.getItem('selectedAccountId'), 10) || undefined,
  kyc: {
    urlParams: null
  },
  qrCode: '',
  verificationLevelConfigs: {}
};
function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case _userActions.USER_INFO_FETCHED:
      return _objectSpread(_objectSpread({}, state), {}, {
        userInfo: payload,
        selectedAccountId: payload.AccountId
      });
    case _userActions.USER_CONFIG_FETCHED:
      return _objectSpread(_objectSpread({}, state), {}, {
        userConfig: payload
      });
    case _kycActions.USER_CONFIG_UPDATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        userConfig: (0, _arrayHelper.updateObjectInArray)(state.userConfig, payload)
      });
    case _userActions.RECEIVE_USER_PERMISSIONS:
      return _objectSpread(_objectSpread({}, state), {}, {
        permissions: payload
      });
    case _userActions.RECEIVE_ACCOUNT:
      return _objectSpread(_objectSpread({}, state), {}, {
        accounts: (0, _uniqBy["default"])([].concat(_toConsumableArray(state.accounts), _toConsumableArray(payload)), 'AccountId')
      });
    case _kycActions.UPDATE_ACCOUNT:
      return _objectSpread(_objectSpread({}, state), {}, {
        accounts: (0, _arrayHelper.updateObjectInArray)(state.accounts, payload)
      });
    case _kycIdentityMindActions.RECEIVE_KYC:
      return _objectSpread(_objectSpread({}, state), {}, {
        kyc: payload
      });
    case _userActions.SET_ACCOUNT:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedAccountId: payload
      });
    case _userActions.SET_GOOGLE_QRCODE:
      return _objectSpread(_objectSpread({}, state), {}, {
        qrCode: payload
      });
    case _userActions.CLEAR_GOOGLE_QRCODE:
      return _objectSpread(_objectSpread({}, state), {}, {
        qrCode: ''
      });
    case _withdrawActions.RECEIVE_VERIFICATION_LEVEL_CONFIGS:
      return _objectSpread(_objectSpread({}, state), {}, {
        verificationLevelConfigs: payload
      });
    default:
      {
        return state;
      }
  }
}